import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { HelpersService } from '../../core/services/helpers.service';
import { OperationsService } from '../../core/services/operations.service';
import { LetteraDiffidaAdapter } from '../components/fascicolo/lettere-diffida-update/lettera-diffida-adapter';
import { Controparte } from '../models/controparte';
import { SezioneContropartiResponse } from '../models/dto/sezione-controparti-response';
import { LetteraDiffida } from '../models/lettera-diffida';
import { SezioneControparti } from '../models/sezioni/sezione-controparti';
import { TipoLettera } from '../models/tipologiche/tipo-lettera';
import { BaseForm } from './base-Form';

declare var removeEmptyObject: any;

export abstract class LettereDiffidaDatiGeneraliForm extends BaseForm {

  // form
  request: LetteraDiffida;
  letteraDiffidaForm: FormGroup;

  // options
  tipiLetteraDiffida: TipoLettera[] = [];
  destinatari: Controparte[] = [];

  constructor(private helpers: HelpersService, protected operations: OperationsService, private campiForm: FormBuilder) {
    super();
  }

  createForm() {
    this.request = new LetteraDiffidaAdapter(this.getLetteraDiffida()).letteraDiffida;
    this.letteraDiffidaForm = this.campiForm.group({
      dataLettera: [this.request.dataLettera, Validators.required],
      destinatario: [this.request.destinatario],
      tipoLettera: [this.request.tipoLettera, Validators.required],
      mittente: [this.request.mittente],
      note: [this.request.note],
      documenti: [this.request.documenti],
    });
  }

  populateSelect(urlReadSezioneControparti: string, idSezioneControparti: string) {
    if (this.tipiLetteraDiffida.length === 0) {
      this.helpers.getTipiLetteraDiffida().subscribe(response => this.tipiLetteraDiffida = response);
    }
/*
    if (this.destinatari.length === 0) {
      this.operations.readSezione(this.getUrlReadSezioneControparti(), idSezioneControparti).subscribe(
        response => this.destinatari = (<SezioneContropartiResponse>response).sezione.controparti);
    }
*/
  }

  readSezioneControparti(idSezioneControparti: string) {
    this.operations.readSezione(this.getUrlReadSezioneControparti(), idSezioneControparti)
      .subscribe(response => this.readSezioneContropartiResponse((<SezioneContropartiResponse>response).sezione));
  }

  readSezioneContropartiResponse(sezioneControparti: SezioneControparti) {
    this.destinatari = sezioneControparti.controparti;
    // this.destinatari = this.destinatari.filter(controparte => { return controparte.ritirato === false; });
  }

  update() {
    this.getRequest(this.request);
  }

  // parametri abstract
  abstract getLetteraDiffida(): LetteraDiffida;
  abstract getRequest(request: LetteraDiffida);
  abstract getUrlReadSezioneControparti(): string;

}
